"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.setUserGuidPromise = exports.getUserGuidPromise = exports.getFrameStart = exports.isFrameStart = void 0;
var ua_parser_js_1 = __importDefault(require("ua-parser-js"));
var web_i18n_1 = require("@snapchat/web-i18n");
var environment_1 = require("../environment");
var session_1 = require("../lifecycle/session");
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var clientId_1 = require("../clientId");
var eventMetadata_1 = require("./eventMetadata");
var isFrameStart = function (item) {
    return item.user_agent !== undefined;
};
exports.isFrameStart = isFrameStart;
var currentFrameStart;
function getFrameStart() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var userGuid, newFrameStart;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4, userGuidPromise];
                case 1:
                    userGuid = _c.sent();
                    newFrameStart = __assign(__assign({}, (partialFrameStart !== null && partialFrameStart !== void 0 ? partialFrameStart : (partialFrameStart = getPartialFrameStart()))), { client_id: (0, clientId_1.getClientId)(), session_id: (_a = (0, session_1.getSessionProperties)()) === null || _a === void 0 ? void 0 : _a.sessionId, app_startup_type: (_b = (0, session_1.getSessionProperties)()) === null || _b === void 0 ? void 0 : _b.appStartupType, user_guid: userGuid !== null && userGuid !== void 0 ? userGuid : undefined });
                    if (!(0, isEqual_1["default"])(currentFrameStart, newFrameStart)) {
                        currentFrameStart = newFrameStart;
                        return [2, newFrameStart];
                    }
                    return [2, null];
            }
        });
    });
}
exports.getFrameStart = getFrameStart;
var osTypesMap = { "MAC OS": "OSX" };
var partialFrameStart;
function getPartialFrameStart() {
    var _a;
    var uaParser = new ua_parser_js_1["default"]();
    var osName = (_a = uaParser.getOS().name) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    var osType = osName ? osTypesMap[osName] || osName : undefined;
    return {
        user_agent: uaParser.getUA(),
        locale: (0, web_i18n_1.getLocale)(),
        os_type: osType,
        os_version: osType,
        app_type: (0, environment_1.getAppEnvironment)().appType,
        app_build: (0, eventMetadata_1.getAppBuild)(),
        app_version: (0, environment_1.getAppEnvironment)().appVersion,
        browser: uaParser.getBrowser().name,
        browser_version: uaParser.getBrowser().version,
        device_model: uaParser.getDevice().model,
        domain: self.location.hostname,
        referrer: (0, eventMetadata_1.getReferrer)()
    };
}
var userGuidPromise = Promise.resolve(null);
function getUserGuidPromise() {
    return userGuidPromise;
}
exports.getUserGuidPromise = getUserGuidPromise;
function setUserGuidPromise(promise) {
    userGuidPromise = promise;
}
exports.setUserGuidPromise = setUserGuidPromise;
//# sourceMappingURL=frameStart.js.map